import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

const Testimonials = ({ testimonials }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="relative">
        <Card className="p-8 sm:p-12 bg-white border-2 border-gray-200">
          <Quote className="w-12 h-12 text-gray-300 mb-6" />
          <p className="text-lg sm:text-xl text-gray-800 leading-relaxed mb-6">
            {testimonials[currentIndex].text}
          </p>
          <p className="text-sm sm:text-base font-medium text-gray-900">
            {testimonials[currentIndex].author}
          </p>
          <p className="text-sm text-gray-600">
            {testimonials[currentIndex].role}
          </p>
        </Card>

        <div className="flex items-center justify-center space-x-4 rtl:space-x-reverse mt-8">
          <Button
            onClick={goToPrevious}
            variant="outline"
            size="icon"
            className="rounded-full border-2 hover:bg-gray-100"
          >
            <ChevronLeft className="w-5 h-5" />
          </Button>
          
          <div className="flex space-x-2 rtl:space-x-reverse">
            {testimonials.map((testimonial, index) => (
              <button
                key={`${testimonial.author}-${index}`}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex ? 'bg-black w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>

          <Button
            onClick={goToNext}
            variant="outline"
            size="icon"
            className="rounded-full border-2 hover:bg-gray-100"
          >
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;